package meineglasfaser.frontend.common.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.navigation.Anchor
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul
import org.w3c.dom.HTMLElement

enum class Theme(val id: String, val icon: String, val title: String) {
    AUTO(
        id = "auto",
        icon = "circle-half",
        title = "System",
    ),
    LIGHT(
        id = "light",
        icon = "sun",
        title = "Hell",
    ),
    DARK(
        id = "dark",
        icon = "moon",
        title = "Dunkel",
    ),
}

private const val THEME_ATTR_NAME = "data-theme"
private const val THEME_STORAGE_KEY = "data-theme"

@Composable
fun ThemeToggle() {
    var currentTheme by remember { mutableStateOf(Theme.AUTO) }
    var detailsElementRef: HTMLElement? = null

    fun updateTheme(theme: Theme) {
        currentTheme = theme
        if (theme == Theme.AUTO) {
            document.documentElement?.removeAttribute(THEME_ATTR_NAME)
        } else {
            document.documentElement?.setAttribute(THEME_ATTR_NAME, theme.id)
        }
        window.localStorage.setItem(THEME_STORAGE_KEY, theme.id)
    }

    LaunchedEffect(Unit) {
        val themeId = window.localStorage.getItem(THEME_STORAGE_KEY)
        val theme = Theme.entries.firstOrNull { it.id == themeId } ?: Theme.AUTO
        updateTheme(theme)
    }

    Details(attrs = {
        classes("dropdown", "right")
        ref {
            detailsElementRef = it
            onDispose { detailsElementRef = null }
        }
    }) {
        Summary {
            BootstrapIcon(currentTheme.icon)
        }
        Ul {
            Theme.entries.forEach { theme ->
                key(theme.id) {
                    Li {
                        Anchor(href = "#", attrs = {
                            onClick {
                                updateTheme(theme)
                                detailsElementRef?.removeAttribute("open")
                            }
                        }) {
                            BootstrapIcon(theme.icon)
                            Text(" ")
                            Text(theme.title)
                        }
                    }
                }
            }
        }
    }
}
